<template>
    <sp-360-panel class="chart-widget" :title="titulo" :tooltipOptions="topTooltipOptions" :footerText="$t(footerText, {fonte: footerFonte, data: footerData})" :footerComplementar="$t(footerComplementar)">
        <sp360-chart :data="data" type="donut" :options="options" class="chart"/>
    </sp-360-panel>
</template>

<script>
import MethGlob from '@/utils/MetodosGlobais'
import Sp360Chart from '@/components/ui/chart/sp360chart'
import Sp360Panel from '@/components/ui/sp360-panel/sp360-panel'

export default {
  name: 'grafico-donut',
  components: { Sp360Chart, Sp360Panel },
  data: () => ({
    topTooltipOptions: { content: '', placement: 'bottom' },
  }),
  props: {
    titulo: { type: String, default: '' },
    data: { type: Object, default: () => { {} } },
    cores: { type: Array, default: () => { [] } },
    options: { type: Object, default: () => { {} } },
    tooltipText: { type: Object, default: { content: '', placement: 'bottom' } },
    footerText: { type: String, default: '' },
    footerFonte: { type: String, default: '' },
    footerData: { type: String, default: '' },
    footerComplementar: { type: String, default: '' },
  },

  mounted () {
    this.topTooltipOptions.content = this.$t(this.tooltipText.content)
    this.topTooltipOptions.placement = this.tooltipText.placement
  },

  methods: {
    dadosDoUltimoMes (dados) {
      let canais = new Array()
      dados.forEach(canal => {
        let item = {}
        item.de_canal = canal.de_canal
        let historico = canal.historico[0]
        item.ano = historico.ano
        item.mes = historico.mes
        item.perc = historico.perc_mes
        item.total = historico.total_mes
        canais.push(item)
      })
      this.titulo = ' ' + this.$t('atendimento.canalDeAtendimentoMensal')
      return canais
    },
    populateDonutChart () {
      let dados = this.dadosDoUltimoMes(this.chartData)
      this.optionsD = {
        responsive: true,
        title: {
          display: false,
          text: '',
        },
        tooltips: {
          // mode: 'index',
          intersect: true,
          callbacks: {
            label: function (tooltipItem, data) {
              var dataLabel = data.labels[tooltipItem.index]
              var value = ': ' + data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index] + '%'
              return (dataLabel += value)
            },
          },
        },
      }
      let palette = this.$store.getters.palette
      this.chartDataD = this.simpleDataset(dados, this.cores.slice(0, dados.lenght), palette.transparent)
    },
    simpleDataset (dados, backgroundColor, borderColor) {
      let palette = this.$store.getters.palette
      let chartData = { labels: [], datasets: [] }
      let dataset = { data: [] }

      dados.forEach(element => {
        chartData.labels.push(element.de_canal)
        dataset.data.push(element.perc)
      })

      dataset.backgroundColor = backgroundColor
      dataset.borderColor = borderColor

      chartData.datasets.push(dataset)

      return chartData
    },
  },
}
</script>

<style>

</style>
